// @flow

import React from 'react';
import { initTrackViews } from 'packs/analytics/trackViews';

export default ({ name = '', properties = {} } : { name: string, properties: {} }) => {
  const analyticsEnabled = window.gon && window.gon.global.advert.analyticsEnabled;
  if (analyticsEnabled) setTimeout(() => initTrackViews(), 300);

  return(
    <span data-event={name} data-properties={JSON.stringify(properties)}> </span>
  );
};
